import global from "@/locales/sv-SE/global";
import error403 from "@/locales/sv-SE/errors/403";
import error404 from "@/locales/sv-SE/errors/404";
import error500 from "@/locales/sv-SE/errors/500";
import error503 from "@/locales/sv-SE/errors/503";
import error504 from "@/locales/sv-SE/errors/504";
import maintenance from "@/locales/sv-SE/auth/maintenance";
import toast from "@/locales/sv-SE/toast/toast";
import login from "@/locales/sv-SE/auth/login";
import onboarding from "@/locales/sv-SE/auth/onboarding";
import loginPageSteps from "@/locales/sv-SE/loginPageSteps";
import dashboard from "@/locales/sv-SE/dashboard/dashboard";
import account from "@/locales/sv-SE/account/account";
import mailbox from "@/locales/sv-SE/account/mailbox";
import bankstatement from "@/locales/sv-SE/account/bankstatement";
import myApps from "@/locales/sv-SE/my-apps/myApps";
import about from "@/locales/sv-SE/about/about";
import contactService from "@/locales/sv-SE/about/contactService";
import salesPromotions from "@/locales/sv-SE/sales/promotions";
import brochures from "@/locales/sv-SE/sales/brochures";
import shop from "@/locales/sv-SE/shop/data";
import priceList from "@/locales/sv-SE/shop/priceList";
import staff from "@/locales/sv-SE/dashboard/staff";
import promotions from "@/locales/sv-SE/promotions";
import points from "@/locales/sv-SE/points";
import trainings from "@/locales/sv-SE/trainings/trainings";
import vouchers from "@/locales/sv-SE/vouchers/vouchers";
import media from "@/locales/sv-SE/media/index";
import product from "@/locales/sv-SE/product/index";
import message from "@/locales/sv-SE/message/index";
import commitmentLetter from "@/locales/sv-SE/account/commitmentLetter";
import multiplicator from "@/locales/sv-SE/multiplicator";
import widgets from "@/locales/sv-SE/widgets/widgets";
import consents from "@/locales/sv-SE/consents/consents";
import investment from "@/locales/sv-SE/investment/data";
import kickback from "@/locales/sv-SE/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Produktbilder",
    BDriveLinkText: "Länk till portalen med PRODUKTBILDER",
  },
}

export default {
  locale: "sv-SE",
  messages,
};
